// extracted by mini-css-extract-plugin
export default {"item":"defaultPadding_item__vm6hQ"};